<template>
  <div class="DeepInfo flex flex-col h-screen bg-purple">
    <div class="logo-header-container ml-8 mt-8">
      <div class="logo-header flex">
        <div class="logo w-32">
          <img class="w-full" src="https://blissing.s3-us-west-1.amazonaws.com/img/blissing_UN_logo_icon_v02.png" alt="blissing blue image logo">
        </div>
        <div class="flex flex-col ml-4">
          <img class="blissing-logo" src="https://blissing.s3-us-west-1.amazonaws.com/img/BLISSING_BW.png" alt="blissing text logo">
          <span class="text-2xl text-left ml-1 font-bold border-4ads border-b-4 leading-none self-start mt-1">DEEP INFO FOR EXPERTS</span>
        </div>
      </div>
    </div>

    <OfferIndex v-if="section == 'index'" />
    <OfferSubOne v-if="section == 'sub-offer-one'" />
    <OfferSubTwo v-if="section == 'sub-offer-two'" />
    <OfferSubThree v-if="section == 'sub-offer-three'" />
    <OfferSubFour v-if="section == 'sub-offer-four'" />
    <OfferSubFive v-if="section == 'sub-offer-five'" />
    <OfferSubSix v-if="section == 'sub-offer-six'" />

    <div v-if="section == 'index'" class="bottom-text">
      <h1 class="heading font-bold italic">Part 1: What does BLISSING offer?</h1>
    </div>

    <div @click="goBack()" class="h-16 w-16 absolute bottom-0 ml-10 mb-10 z-50">
      <img class="arrow up cursor-pointer" src="https://blissing.s3-us-west-1.amazonaws.com/img/Arrow-up.png" alt="arrow up">
    </div>

    <Navigation textColor="black"/>

  </div>
</template>

<script>
import OfferIndex from "@/components/deepinfo/offer/Index.vue";
import OfferSubOne from "@/components/deepinfo/offer/SubOne.vue";
import OfferSubTwo from "@/components/deepinfo/offer/SubTwo.vue";
import OfferSubThree from "@/components/deepinfo/offer/SubThree.vue";
import OfferSubFour from "@/components/deepinfo/offer/SubFour.vue";
import OfferSubFive from "@/components/deepinfo/offer/SubFive.vue";
import OfferSubSix from "@/components/deepinfo/offer/SubSix.vue";
import Navigation from "@/components/Navigation.vue";

export default {
  name: "DeepInfoOffer",
  components:{
    OfferIndex,
    OfferSubOne,
    OfferSubTwo,
    OfferSubThree,
    OfferSubFour,
    OfferSubFive,
    OfferSubSix,
    Navigation
  },
  data(){
    return{
      section: 'index'
    }
  },
  methods:{
    showCard(card){
      if (card != 'deep-info-main-menu') {
        this.section = card;
      } else {
        this.$router.push({name: 'DeepInfo'});
      }
    },
    goBack(){
      if (this.section == 'index') {
        this.$router.go(-1);
      }else {
        this.showCard('index');
      }
    }
  },
  mounted(){
    Event.$on('clickedCard', (data) => {this.showCard(data)});
  }
}
</script>

<style lang="css" scoped>

.blissing-logo{
  width: 20rem;
}

</style>
